import React from 'react';
import { FormattedMessage } from 'react-intl';

import AiIcon from '../../../../../components/AiIcon';

import { DOCUMENTATION_PATH } from '../../../../../constants/routes';

const INSTALL_GUIDE_URL = `${DOCUMENTATION_PATH}#/category1/Article%201`;

const EXPERT_ADVISOR_URL =
  'https://neural-app.s3.eu-west-1.amazonaws.com/mt5/NeuralTrading.mq5';

const Mt5TabContent = () => (
  <div className="files-page__atlas-download-mt5">
    <div className="files-page__atlas-download-instructions">
      <p className="files-page__atlas-download-description">
        <FormattedMessage id="files.mt5Modal.description" />
      </p>
      <a
        className="files-page__atlas-download-guide"
        href={INSTALL_GUIDE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiIcon name="download-installInstruction" />
        <FormattedMessage id="files.atlasDownloadModal.installGuide" />
      </a>
    </div>

    <div className="files-page__atlas-download-cards">
      <article className="files-page__atlas-download-card">
        <AiIcon name="download-mql5" />
        <h3 className="files-page__atlas-download-card-title">
          <FormattedMessage id="files.mt5Modal.platform.expert" />
        </h3>
        <p className="files-page__atlas-download-card-subtitle">
          <FormattedMessage id="files.mt5Modal.platform.expertSubtitle" />
        </p>
        <a
          className="files-page__atlas-download-card-btn"
          href={EXPERT_ADVISOR_URL}
          download
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="files.atlasDownloadModal.download" />
        </a>
      </article>
    </div>
  </div>
);

export default Mt5TabContent;
